import { map } from 'rxjs/operators/map';
import { SaveStagedChangesRequestTypes, clearAllChanges } from '../actions/StagingActions';
export default ($action => {
  return $action.ofType(SaveStagedChangesRequestTypes.SUCCESS, SaveStagedChangesRequestTypes.FAILURE).pipe(map(() => {
    return clearAllChanges();
  }));
});